import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const moment = require("moment");
import * as React from "react";
import { nextEvent } from "../../../../Shared/components/Events/EventOverview/EventOverviewLayout/EventOverviewResult";
import { formatDatesShort } from "../../../../Shared/components/Events/EventUtils";
import { ResponsivePicture, singleCrop } from "../../../../Shared/components/Image";
import { Text } from '../../../../Shared/components/Text';
import { features } from "../../../../Shared/features";
import { slugify } from "../../../../Shared/utils/string";
import { LinkButton } from "../library/button";
import { Link } from "../library/link";
export const TippedActivitiesLayout = (props)=>{
    const { title, content, linkTitle, linkUrl, row_count, events } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "page-block",
        children: /*#__PURE__*/ _jsx("div", {
            className: "block block--tips",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "block__inner",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: "block__header",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                "data-anchor": slugify(title),
                                className: "block__title title--m",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "block__intro text--styled",
                                dangerouslySetInnerHTML: {
                                    __html: content
                                }
                            }),
                            /*#__PURE__*/ _jsx(LinkButton, {
                                route: linkUrl,
                                children: linkTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "block__content",
                        children: /*#__PURE__*/ _jsx("ul", {
                            className: "row teasers",
                            children: events.kind == "loaded" && events.value.Result.map((e, i)=>/*#__PURE__*/ _jsx(TippedActivitySummary, {
                                    ...e,
                                    headingLevel: "h3",
                                    onClick: ()=>{},
                                    row_count: row_count
                                }, `activity-summary-${i}`))
                        })
                    })
                ]
            })
        })
    });
};
const TippedActivitySummary = (p)=>{
    const { Id, Title, TargetId, row_count, onClick } = p;
    const config = features().events;
    if (config == 'off') return null;
    const url = `${config.prefix}/${TargetId}`;
    return /*#__PURE__*/ _jsx("li", {
        className: `teaser teaser--image tip-activity ${row_count == 4 ? 'col-xs-12 col-sm-6 col-md-4 col-ld-3' : 'col-xs-12 col-sm-6 col-md-4'}`,
        children: /*#__PURE__*/ _jsx(Link, {
            url: url,
            className: "teaser__link",
            handle: ()=>onClick && onClick(),
            "aria-labelledby": `a11y-teaser-title-${slugify(Title)}`,
            children: /*#__PURE__*/ _jsx(TippedTeaserContent, {
                ...p
            })
        }, Id)
    });
};
export const TippedTeaserContent = (p)=>{
    var _nextEvent_Locations_;
    const { Title, TeaserText, Image, Start, Locations } = p;
    const Heading = p.headingLevel;
    // If there's more than 1 location, we attach an alphabetized list as title on the `address` element
    const [locationName, addressAttributes] = Locations.length == 1 ? [
        (_nextEvent_Locations_ = nextEvent(p).Locations[0]) === null || _nextEvent_Locations_ === void 0 ? void 0 : _nextEvent_Locations_.Name,
        {}
    ] : [
        "Meerdere locaties",
        {
            title: Locations.map((l)=>l.Name).sort().join('\n')
        }
    ];
    const dateAndTime = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("time", {
                className: "teaser__meta-item teaser__date",
                dateTime: moment(Start).format('YYYY-MM-DD'),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon-calendar",
                        "aria-hidden": "true"
                    }),
                    formatDatesShort(p)
                ]
            }),
            /*#__PURE__*/ _jsxs("address", {
                className: "teaser__meta-item teaser__location",
                ...addressAttributes,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon-map-pin",
                        "aria-hidden": "true"
                    }),
                    locationName
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsxs("article", {
        className: "teaser__inner",
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "teaser__header",
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        className: "teaser__title title--m",
                        id: `a11y-teaser-title-${slugify(Title)}`,
                        children: /*#__PURE__*/ _jsx("span", {
                            dangerouslySetInnerHTML: {
                                __html: Title
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "teaser__meta text--s",
                        children: dateAndTime
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "teaser__content",
                children: [
                    TeaserText && /*#__PURE__*/ _jsx(Text, {
                        ...TeaserText,
                        className: "teaser__intro"
                    }),
                    Image && /*#__PURE__*/ _jsx("div", {
                        className: "teaser__visual",
                        children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                            defaultImageUrl: Image.Fallback,
                            cropsPerMedia: singleCrop(Image.Teaser),
                            alt: Image.AltText,
                            className: "teaser__image"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("footer", {
                className: "teaser__fauxlink",
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: "teaser__fauxlink-icon",
                        width: "8px",
                        height: "14px",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#icon--chevron-right"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: "Bekijk activiteit"
                    })
                ]
            })
        ]
    });
};
